import { useAnalyticsEvents } from '../hooks/useAnalyticsEvents'

export const handleProductCardSeeMore = () => {
  const { genericTaggingEvent } = useAnalyticsEvents()

  genericTaggingEvent('see_all_card', {
    name: location,
  })
}
